import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import logo from '../assets/lone-wolf-logo.png';

const LogoWrapper = styled.div`
  width: 95px; /* Set the width of the logo */
  transition: transform 0.2s ease; /* Add transition effect */
  
  &:hover {
    transform: scale(1.1); /* Scale up on hover */
  }
`

const Logo = () => {
  const handleClick = () => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  };

  return (
    <Link to="/" onClick={handleClick}> {/* Link to the main page */}
      <LogoWrapper>
        <img width={95} height={'auto'} src={logo} alt={"name"} />
      </LogoWrapper>
    </Link>
  )
}

export default Logo